export type PaymentMethod = 'cash' | 'tpv';

/**
 * Preferencias de cobro de taquilla (por navegador, en localStorage).
 * Con "cobro directo" pulsar el método de pago registra el pedido sin pasar
 * por la pantalla de importe recibido (efectivo) o de confirmación (tarjeta).
 */
const DIRECT_PAYMENT_KEYS: Record<PaymentMethod, string> = {
  cash: 'pay_direct_cash',
  tpv: 'pay_direct_tpv',
};

export function isDirectPayment(method: PaymentMethod): boolean {
  return localStorage.getItem(DIRECT_PAYMENT_KEYS[method]) === 'true';
}

export function setDirectPayment(method: PaymentMethod, direct: boolean): void {
  localStorage.setItem(DIRECT_PAYMENT_KEYS[method], String(direct));
}
